<template>
<div class="lesson-templates">
  <h1 class="title grey--text">排课</h1>
  <v-container class="my-5">
    <v-layout justify-center class="pa3 caption">
      <v-flex xs12 sm10 md8>
        <v-select
          v-model="programIds"
          :items="programs"
          item-text="title"
          item-value="program_id"
          label="所选项目"
          small-chips
          multiple
          prepend-icon="ballot"
          menu-props="offsetY"
          @change="updateTemplates"
        ></v-select>
      </v-flex>
    </v-layout>

    <v-card
      v-for="(lessonTemplate, lessonTemplateIndex) in lessonTemplatesShow" v-bind:key="`template-${lessonTemplateIndex}`"
      :class="`my-5 lesson-template template-overall-status-code-${lessonTemplate.lessonTemplateOverallStatusCode}`"
    >
      <v-layout column>
        <div class="px-5 pt-5">
          <v-flex>
            <div class="caption grey--text">{{ lessonTemplate.program_title }}</div>
          </v-flex>
          <v-flex>
            <div class="title">{{ lessonTemplate.title }}
              <v-btn
                text
                icon
                color="grey"
                @click="$router.push({
                  name: 'edit-lesson-template',
                  params: {
                    lessonTemplateId: lessonTemplate.template_id
                  }
                })"
              >
                <v-icon small>edit</v-icon>
              </v-btn>
            </div>
          </v-flex>
          <div class="">
                <span class="caption"><v-icon small>person</v-icon> {{ lessonTemplate.tutor }}</span>
          </div>
          <div class="py-2"></div>
          <v-flex>
            <v-btn
              color="grey"
              outlined
              rounded
              small
              @click="lessonEnrollment(lessonTemplate.program_id, lessonTemplate.template_id, lessonTemplateIndex)"
            >
              编辑场次
              <v-icon small>edit</v-icon>
            </v-btn>
          </v-flex>
        </div>
        <v-divider class="mt-3"></v-divider>
        <v-flex v-if='lessonTemplate.lessonSessions.length' class="d-flex justify-center" @click="lessonTemplate.show = !lessonTemplate.show">
          <v-btn text block small tile>
            <span class="caption grey--text">{{lessonTemplate.show ? '收起' : '展开'}}全部{{lessonTemplate.lessonSessions.length}}场次</span>
            <v-icon small>{{ lessonTemplate.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
          </v-btn>
        </v-flex>
        <v-flex>
          <v-slide-y-transition>
            <v-card-text v-show="lessonTemplate.show" class="grey--text">

              <v-divider></v-divider>

              <div class="mb-3">
                <v-card
                  v-for="(lessonSession, lessonSessionIndex) in lessonTemplate.lessonSessions" v-bind:key="`lesson-session-${lessonSessionIndex}`"
                >
                  <v-layout class="pa-3 mx-3" row wrap>
                    <v-flex xs12 lg3>
                      <span class="subtitle-1">{{ lessonSession.class }}</span>
                    </v-flex>
                    <v-flex xs12 lg3>
                      <v-icon small>location_on</v-icon>
                      <span class="caption grey--text">{{ lessonSession.venue_name }}</span>
                    </v-flex>
                    <v-flex xs12 lg2>
                      <v-icon small>schedule</v-icon>
                      <span class="caption grey--text">{{ format(new Date(lessonSession.time), "yyyy/M/d(EEE) HH:mm")}}</span>
                    </v-flex>
                    <v-flex xs10 lg3>
                      <v-chip
                        :color="`${lessonSession.status_code == 2 ? 'green': (lessonSession.lastestAutoConfirmTime === null ? 'light-green' : 'orange') }`"
                        text-color="white"
                        small
                      >
                        <span>{{ lessonSession.status }}</span>
                        <span v-if="lessonSession.status_code === 1 && lessonSession.lastestAutoConfirmTime">{{`-自动确认: ${lessonSession.lastestAutoConfirmTime}`}}</span>
                        <span v-if="lessonSession.status_code === 1 && lessonSession.lastestAutoConfirmTime === null">-可结课</span>
                        <v-avatar right v-if="lessonSession.status_code === 1 && lessonSession.lastestAutoConfirmTime === null"><v-icon small>check_circle</v-icon></v-avatar>
                      </v-chip>
                    </v-flex>
                    <v-flex xs2 lg1>
                      <div class="d-flex justify-end">
                        <div class="caption grey--text">{{lessonSession.lessonEnrollmentInfo.length}}人</div>
                        <v-btn x-small icon @click="lessonSession.show = !lessonSession.show">
                          <v-icon x-small>{{ lessonSession.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>

                  <!-- 签到具体情况 -->
                  <v-slide-y-transition>
                    <v-card text>
                      <v-card-text v-show="lessonSession.show" class="grey--text">
                        <span v-for="(lessonSessionEnrollment, enrollmentIndex) in lessonSession.lessonEnrollmentInfo" v-bind:key="`enrollment-${enrollmentIndex}`">
                          <v-chip
                            :color="`${lessonSessionEnrollment.attendance_code == 2 ? 'green lighten-3': 'red lighten-2'}`"
                            text-color="white"
                            class="ma-1"
                            small
                          >
                            <span class="caption">{{ lessonSessionEnrollment.student }}[{{ lessonSessionEnrollment.attendance_status }}]</span>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-avatar v-if="lessonSessionEnrollment.confirmation_code === 0" right>
                                  <v-icon small v-on="on"> hourglass_empty </v-icon>
                                </v-avatar>
                              </template>
                              <span> 等待学员确认 </span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-avatar v-if="lessonSessionEnrollment.confirmation_code === 1" right>
                                  <v-icon small v-on="on"> check_circle </v-icon>
                                </v-avatar>
                              </template>
                              <span> 状态已确认 </span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-avatar v-if="lessonSessionEnrollment.confirmation_code === 2" right>
                                  <v-icon small v-on="on"> error </v-icon>
                                </v-avatar>
                              </template>
                              <span> 状态未得到确认，请协商或修改 </span>
                            </v-tooltip>
                          </v-chip>
                          <!-- 学员确认按键(应转至学员界面) -->
                          <!-- <v-btn text icon color="green"
                            v-if="lessonSessionEnrollment.confirmation_code != 1"
                            :disabled = "lessonSessionEnrollment.attendance_code === 1"
                            @click="studentAttendanceStatusFeedback(lessonSessionEnrollment.lesson_enrollment_id, 1)">
                            <v-icon>check_circle</v-icon>
                          </v-btn> -->
                        </span>
                      </v-card-text>
                    </v-card>
                  </v-slide-y-transition>
                </v-card>
              </div>
              <div class="mb-3" v-if="lessonTemplate.description">
                <v-subheader>活动详情
                  <v-btn
                    text
                    icon
                    color="grey"
                    @click="$router.push({
                      name: 'edit-lesson-template',
                      params: {
                        lessonTemplateId: lessonTemplate.template_id
                      }
                    })"
                  >
                    <v-icon small>edit</v-icon>
                  </v-btn>
                </v-subheader>
                {{ lessonTemplate.description | truncate(60) }}
              </div>
            </v-card-text>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
    </v-card>
    <v-layout justify-center class="my-2">
      <v-btn
        text
        outlined
        color="grey"
        :loading="loading"
        :disabled="loading"
        @click="loadMore">
        加载更多
        <template v-slot:loader>
          <span class="custom-loader">
            <v-icon light>cached</v-icon>
          </span>
        </template>
      </v-btn>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import ProgramService from '@/services/ProgramService'
import LessonService from '@/services/LessonService'
import format from 'date-fns/format'

export default {
  components: {
  },
  filters: {
    truncate: function (value, limit) {
      if (value.length > limit) {
        value = value.substring(0, (limit - 3)) + '...'
      }
      return value
    }
  },
  data () {
    return {
      format,
      tutorId: null,
      programs: [],
      programIds: [],
      lessonTemplates: [],
      // enrollmentSystemAutoConfirmMs: 0,
      lessonTemplatesShow: [],
      classes: [],
      loading: false
    }
  },
  async mounted () {
    // set queryingState
    this.$store.dispatch('setQueryingState', true)

    // get programs by organizationGroups
    if (this.$store.state.account.organizationGroupManager.organizationGroups.length > 0) {
      const organizationGroups = this.$store.state.account.organizationGroupManager.organizationGroups
      const organizationGroupIds = organizationGroups.map(organizationGroup => organizationGroup.organization_group_id)
      // get programs
      this.$store.dispatch('setQueryingState', true)
      const res = await ProgramService.getCategorizedPrograms({ organizationGroupIds, isPublished: true, isDraft: true, isPending: true, isClosed: true })
      this.programs = this.programs.concat(res.data.publishedPrograms, res.data.draftPrograms, res.data.pendingPrograms, res.data.closedPrograms)
    }

    // Initialize programIds to include all programs under the organization
    this.programs.forEach((program) => {
      if (program.status_code > 0) {
        this.programIds.push(program.program_id)
      }
    })
    console.log('programIds: ', this.programIds)

    // get lessonTemplates by tutor Id (tutor can only see self-managed templates)
    this.lessonTemplates = await this.getFullLessonTemplatesInfo(6)

    // set classesShow for display
    this.lessonTemplatesShow = this.lessonTemplates

    // get classes by programId
    console.log(this.programIds)
    const resClasses = await ProgramService.getClasses({ programIds: this.programIds, statusCodes: [1] }) // status_code: 1 -> active
    this.classes = resClasses.data
    console.log('classes retrived! classes: ', this.classes)

    // set queryingState
    this.$store.dispatch('setQueryingState', false)
  },
  methods: {
    async scroll () { // dynamically load lesson templates and trigger something if user reaches the bottom !
      window.onscroll = async () => {
        const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight
        if (bottomOfWindow) {
          this.loadMore()
        }
      }
    },
    async loadMore () {
      console.log('load more lesson templates!')
      const newLessonTemplates = await this.getFullLessonTemplatesInfo(3)
      this.lessonTemplates.push(...newLessonTemplates)
    },
    async getFullLessonTemplatesInfo (limit) {
      this.loading = true
      // get lesson Templates
      const resLessonTemplateInfo = await LessonService.getLessonTemplates({ programIds: this.programIds, offset: this.lessonTemplates.length, limit: limit })
      const lessonTemplateInfo = resLessonTemplateInfo.data
      // get session info for each lesson Template
      const lessonTemplateIds = []
      lessonTemplateInfo.forEach((lessonTemplate) => {
        lessonTemplateIds.push(lessonTemplate.template_id)
      })
      const resLessonSessions = await LessonService.getLessonSessions({ lessonTemplateIds })
      const lessonSessions = resLessonSessions.data
      // get enrollment info for each lesson session
      const lessonIds = []
      lessonSessions.forEach((lessonSession) => {
        lessonIds.push(lessonSession.id)
      })
      const resEnrollments = await LessonService.getLessonEnrollments({ lessonIds })
      const enrollments = resEnrollments.data
      // attach enrollment info to each lesson session
      lessonSessions.forEach((lessonSession) => {
        const lessonEnrollmentsForThisSession = enrollments.filter((enrollment) => {
          return lessonSession.id === enrollment.lesson_id
        })
        lessonSession.lessonEnrollmentInfo = lessonEnrollmentsForThisSession
        const lastestUnconfirmedLessonEnrollmentTimestampUpdate = Math.max(...lessonSession.lessonEnrollmentInfo.map(function (item) { return item.confirmation_code === 1 ? null : new Date(item.lesson_enrollment_timestamp_update) }))
        lessonSession.lastestAutoConfirmTime = lastestUnconfirmedLessonEnrollmentTimestampUpdate === 0 ? null : format(new Date(lastestUnconfirmedLessonEnrollmentTimestampUpdate + lessonTemplateInfo[0].lesson_enrollment_system_auto_confirm_ms), 'MM/dd HH:mm')
        lessonSession.show = false
      })
      // attach lesson sessions to each template
      lessonTemplateInfo.forEach((lessonTemplate) => {
        const lessonSessionsForThisTemplate = lessonSessions.filter((lessonSession) => {
          return lessonSession.lesson_template_id === lessonTemplate.template_id
        })
        lessonTemplate.lessonSessions = lessonSessionsForThisTemplate

        // calculate and inject lessonTemplateOverallStatusCode (see definition below)
        let lessonTemplateOverallStatusCode = 0 // 0: scheduled without any session, 1: session waiting for finalized, 2: finalized
        if (lessonSessionsForThisTemplate.length > 0) {
          lessonTemplateOverallStatusCode = 1
          let allSessionFinalized = true // flag
          lessonSessionsForThisTemplate.forEach((lessonSession) => {
            if (lessonSession.status_code !== 2) allSessionFinalized = false // if any one session is not finallized, set to false
          })
          if (allSessionFinalized) lessonTemplateOverallStatusCode = 2 // if all have been finalized, set overall statusCode to 2
        }
        lessonTemplate.lessonTemplateOverallStatusCode = lessonTemplateOverallStatusCode

        // 根据lessonTemplateOverallStatusCode 来决定初始状态是否将此课展开
        if (lessonTemplate.lessonTemplateOverallStatusCode === 1) {
          lessonTemplate.show = true
        } else {
          lessonTemplate.show = false
        }
      })
      // loading status => false
      this.loading = false
      // get overall status
      return lessonTemplateInfo
    },
    async deleteLessonTemplate (lessonTemplateId) {
      console.log('deleteLessonTemplate starts ... lessonTemplateId: ', lessonTemplateId)
      const res = await LessonService.deleteLessonTemplate(lessonTemplateId)
      console.log('res: ', res)
      console.log('res.data.lessonTemplate.id: ', res.data.lessonTemplate.id, '; lessonTemplateId: ', lessonTemplateId)
      if (res.data.lessonTemplate.id === lessonTemplateId) { // lessontemplate deleted, async the array
        console.log('lessonTemplate is deleted! id: ', res.data.lessonTemplate.id)
        // const self = this
        this.lessonTemplates.map(function (lessonTemplate, index) {
          console.log('index: ', index, '; lessonTemplate.id: ', lessonTemplate.id)
          if (lessonTemplate.template_id === lessonTemplateId) {
            console.log('found index: ', index, 'sync the lessonTemplates array...')
            this.lessonTemplates.splice(index, 1)
          }
        })
      }
    },
    async updateTemplates () {
      console.log('Input event triggered! programeIds: ', this.programIds)

      // set queryingState
      this.$store.dispatch('setQueryingState', true)

      // update lessonTemplatesShow
      console.log('Begin updating the lessonTemplatesShow ...')
      // const self = this
      this.lessonTemplatesShow = this.lessonTemplates.filter(function (singleTemplate) {
        return this.programIds.indexOf(singleTemplate.program_id) >= 0
      })
      console.log('this.lessonTemplatesShow: ', this.lessonTemplatesShow)

      // set queryingState
      this.$store.dispatch('setQueryingState', false)
    },
    async studentAttendanceStatusFeedback (lessonEnrollmentId, confirmationCode) {
      console.log('Student feedback initiated (lessonEnrollmentId:', lessonEnrollmentId, '): code:', confirmationCode)
      await LessonService.studentAttendanceStatusFeedback(lessonEnrollmentId, confirmationCode)
      console.log('Successful!')
    },
    async lessonEnrollment (programId, lessonTemplateId) {
      // prepare classes
      const programClasses = this.classes.filter(function (el) {
        return el.program_id === programId
      })
      console.log('classes under current program are filtered to be: ', programClasses)

      // route
      this.$router.push({
        name: 'lesson-enrollment',
        params: {
          programId: programId,
          lessonTemplateId: lessonTemplateId,
          classes: programClasses
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .lesson-template.template-overall-status-code-2 {
    border-left: 4px solid #3cd1c3;
  }
  .lesson-template.template-overall-status-code-1 {
    border-left: 4px solid orange;
  }
  .lesson-template.template-overall-status-code-0 {
    border-left: 4px solid grey;
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
